// Requests behind the notification bell. See docs/plans/notifications-redesign.md.

import { Request } from 'components/Request';

export const NOTIFICATION_PAGE_SIZE = 20;

// GET bootstrap?fields=notifications, unwrapped to the section itself.
export function fetchNotificationsSection() {
	return Request.apiv1Get('bootstrap', { fields: 'notifications' })
		.then((response) => (response && response.sections ? response.sections.notifications : null));
}

export function fetchNotificationPage(beforeId) {
	const data = { limit: NOTIFICATION_PAGE_SIZE };
	if(beforeId) {
		data.before_id = beforeId;
	}
	return Request.apiv1Get('notifications', data);
}

export function postNotificationsRead(ids) {
	return Request.apiv1Post('notifications/read', { ids: ids.join(',') });
}

export function postAllNotificationsRead() {
	return Request.apiv1Post('notifications/read', { all: 1 });
}

export function postNotificationsToasted(ids) {
	return Request.apiv1Post('notifications/toasted', { ids: ids.join(',') });
}

// Chats_Controller::reject_invite
export function declineChatInvite(chatRoomId) {
	return Request.post(`${window.siteUrl}/chats/reject_invite/${chatRoomId}`, {});
}
